module.exports = __webpack_public_path__ + "media/images/tunnel_emoji/face-with-rolling-eyes-f3d8c11dbbecf3ae57dade9626f79690.png";